module.exports = __webpack_public_path__ + "img/13.72c5ad01.jpg";